function HyperLink({link}) {
    return(
        <a href={link.url} target={link.target}>{link.displayText}</a>
    );
}

export default HyperLink;